import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();
  const [showMoreInfo, setShowMoreInfo] = useState(false);
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p dangerouslySetInnerHTML={{ __html: t('titles', 'designDisclaimer') }} />
      
      {!showMoreInfo ? (
        <p>
          <span id="more" onClick={() => setShowMoreInfo(true)}>
            {t('common', 'moreInfo')}
          </span>
        </p>
      ) : (
        <p id="more-info" dangerouslySetInnerHTML={{ __html: t('longTexts', 'moreInfoText') }}>
        </p>
      )}
      
      <p>&copy; {currentYear} PanWor</p>
    </footer>
  );
};

export default Footer;